import authMiddleware from './auth';
import { MiddlewareContext } from '@/interfaces/middleware';
import User from '@/models/user';

export default async (context: MiddlewareContext) => {
  const authMiddlewareRedirect = await authMiddleware(context);
  const user: User | null = context.store.state.user.user;

  if (user === null || user.isAdmin) {
    return authMiddlewareRedirect;
  }

  return {
    name: 'root',
    replace: true
  };
};
